// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 747 ? "8abc4a02" : chunkId) + "." + {"247":"1f6a72da536b3920","747":"3b183ce3bfb19478"}[chunkId] + ".js";
};